<app-spinner [loading]="cryptotokens().loading || profiles().loading || caNames().loading"></app-spinner>
<app-create-ca [cryptotokens]="cryptotokens().list"
  [profiles]="profiles().list"
  [caNames]="caNames().list"
  [cryptotokenKeys]="cryptotokenKeys"
  [loadingCryptotokenKeys]="loadingCryptotokenKeys"
  (needCryptotokenKeys)="onNeedCryptotokenKeys($event)"
  (create)="onCreate($event)"
  (cancelCreate)="onCancel()"
  [creating]="isCreating">
</app-create-ca>
